<template lang="pug">
  v-dialog.row.justify-center(persistent v-model="openWhatsappDialog" max-width="300")
    v-card
      v-btn.close-button(flat icon @click="$emit('closeWhatsappDialog')")
        i.close.material-icons clear
      v-card-title
          img.participe-icon(src="@/assets/img/icons/participe.svg")
          span.asu-title {{ title }}
      v-card-text
        v-layout.text-md-center
          span.v-list-tile-text Este proyecto no cuenta con un número de whatsapp habilitado para comunicarte.
</template>
<script>
export default {
  data () {
    return {
      finished: false,
      success: false,
      title: 'Participa',
      openWhatsappDialog: false
    }
  },
  props: {
    openDialog: {
      default: false,
      type: Boolean
    },
    projectInfo: Object
  },
  methods: {
    openGuiaParticipacion () {
      this.$emit('on-help-click')
    }
  },
  watch: {
    openDialog (isOpen) {
      this.openWhatsappDialog = !!isOpen
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/variables'

.asu-title
  color: rgb(13, 37, 99)
  font-weight: bold
  font-family: 'Raleway', serif
  font-size: 1em
  font-weight: bold
  padding: 0
  vertical-align: middle

.asu-title-icon
  width: $f85px

.description
  color: gray
  font-family: 'Raleway', serif
  font-size: $f20px
  font-weight: bold
  display: inline-block
  padding-bottom: $f15px

.participe
  color: $color_0
  user-select: none

.participe-icon
  height: 20px
  margin: 0

.success
  text-align: center
  font-size: 20px
  font-family: 'Raleway', serif

.v-card__text
  padding-top: 0

.ap-comment-icon
  text-align: center
  padding-left: 24px

form
  height: 100%
  box-sizing: border-box

.v-list >>> .v-list__tile--link
  min-height: 30px

.v-list__group
  & >>> .v-list__group__items
    padding-left: $f30px

.v-list-tile-text
  color: rgb(13, 37, 99)
  padding: $f5px 0
  white-space: pre-wrap
  word-break: break-word
  width: 100%

.v-progress-linear
  margin: 0

.close-button
  float: right
  height: auto
  width: auto

.number-content
  display: flex
  flex-direction: row
  justify-content: center
  width: 100%

.ap-whatsapp
  margin-right: .5rem

.v-dialog__content >>> .v-dialog.v-dialog--active
  min-width: $f280px
  max-width: 80%
  max-height: 80%
  .isMobile &
    width: 100vmax
    min-width: 100%
    max-width: 100%
    max-height: 100%
    margin-left: 0
    margin-right: 0
    .v-card
      padding-top: $f15px

</style>
